import { makeStyles } from '@material-ui/core'

export const useStyle = makeStyles((theme) => {
  return {
    formGroup: {
      width: '100%',
    },
    group: {
      width: '100%',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'flex-start',
      alignItems: 'center',
      flexWrap: 'wrap',
      marginBottom: 32,
      gap: 8,
    },
    item: {
      marginRight: 0,
      marginLeft: 0,
      color: theme.palette.secondary.dark,
      border: `1px solid ${theme.palette.secondary.dark}`,
      padding: '8px 16px',
      transition: 'all ease 0.3s',
      borderRadius: 8,
      backgroundColor: 'white',
      '& .MuiButtonBase-root': {
        display: 'none',
      },
      '& .MuiTypography-root': {
        color: theme.palette.secondary.dark,
        fontSize: 14,
        fontWeight: 500,
        lineHeight: '24px',
        textTransform: 'initial',
        transition: 'all ease 0.3s',
        [theme.breakpoints.down('xs')]: {
          width: '100%',
          textAlign: 'center',
        },
      },
      [theme.breakpoints.down('xs')]: {
        padding: '8px 16px',
        marginBottom: 8,
        minWidth: 'calc(50% - 8px)',
      },
      '&:hover': {
        color: theme.palette.primary.main,
        border: `1px solid ${theme.palette.primary.main}`,
        '& .MuiTypography-root': {
          color: theme.palette.primary.main,
          transition: 'all ease 0.3s',
        },
      },
    },
    itemActive: {
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.primary.light,
      border: `1px solid ${theme.palette.primary.main}`,
      '& .MuiTypography-root': {
        color: theme.palette.primary.main,
      },
    },
  }
})
